"use strict";

class TlCommonMenuLinks {
    constructor(config) {
        this.links = [
            // 抽屉（公共-底部）导航 start
            {
                key: "webs_drawer_footer_menu",
                info: {
                    title: '成员管理',
                    sort: 1,
                    path: '/memberCenter/team',
                    url: `${config.baseUrl.hosts.host}/memberCenter/team`,
                    img: "https://res.tuoluocard.com/bixiao-web-static/image/common-drawer-menu/partner-black.svg",
                    apply: 'crm'
                },
            },
            {
                key: "webs_drawer_footer_menu",
                info: {
                    title: '管理中心',
                    sort: 2,
                    auths: [0],
                    roles: ['centerControl', 'sys:centerControl'],
                    path: '/setting',
                    url: `${config.baseUrl.hosts.host}/setting`,
                    img: "https://res.tuoluocard.com/bixiao-web-static/image/common-drawer-menu/setting.svg",
                    apply: 'crm'
                }
            },
            // 抽屉（公共-底部）导航 end

            // 抽屉（公共）导航 start
            {
                key: "webs_drawer_menu",
                info: {
                    title: 'CRM',
                    sort: 2,
                    path: '/crm/kanban',
                    url: `${config.baseUrl.hosts.host}/crm/kanban`,
                    img: "https://res.tuoluocard.com/bixiao-crm/statics/common-menu-drawer/managment.svg",
                    description: "全流程销售管理<br/>赋能业绩增长",
                    apply: 'crm',
                    validatorOpenApp: true
                },
            },
            {
                key: "webs_drawer_menu",
                info: {
                    title: 'Project',
                    sort: 3,
                    path: '/project-list/all',
                    url: `${config.baseUrl.hosts.pm}/project-list/all`,
                    img: "https://res.tuoluocard.com/bixiao-web-static/image/common-drawer-menu/project.svg",
                    description: "让每个项目成为<br/>一个成功案例",
                    apply: 'pm',
                    validatorOpenApp: true
                },
            },
            {
                key: "webs_drawer_menu",
                info: {
                    title: 'OA外勤',
                    sort: 4,
                    path: '/fieldwork/statistics',
                    url: `${config.baseUrl.hosts.oa}/fieldwork/statistics`,
                    img: "https://res.tuoluocard.com/bixiao-web-static/image/common-drawer-menu/chengyuanicon.svg",
                    description: "便捷移动化打卡<br/>快速拜访客户",
                    apply: 'oa'
                },
            },
            {
                key: "webs_drawer_menu",
                info: {
                    title: '微名片',
                    sort: 5,
                    path: '/card',
                    url: `${config.baseUrl.hosts.card}/card`,
                    img: "https://res.tuoluocard.com/bixiao-web-static/image/common-drawer-menu/card.svg",
                    description: "搭建企业<br>私域流量",
                    apply: 'card',
                    validatorOpenApp: true
                },
            },
            // 抽屉（公共）导航 end

            // 下拉（用户）导航 start
            {
                key: "user_drop_menu",
                info: {
                    title: '个人设置',
                    sort: 0,
                    path: "/account/persinfo",
                    url: `${config.baseUrl.hosts.host}/account/persinfo`,
                    apply: 'crm'
                },
            },
            {
                key: "user_drop_menu",
                info: {
                    title: '进入官网',
                    sort: 1,
                    icon: "tl-icon-guanwang",
                    path: "/home",
                    url: `${config.baseUrl.hosts.host}/home`,
                    apply: 'crm'
                },
            },
            {
                key: "user_drop_menu",
                info: {
                    title: '企业资料',
                    sort: 2,
                    icon: "tl-icon-ziliao",
                    path: "/setting_base/compinfo",
                    url: `${config.baseUrl.hosts.host}/setting_base/compinfo`,
                    apply: 'crm',
                    roles: ['sys:bas:enterpriseinfo']
                },
            },
            {
                key: "user_drop_menu",
                info: {
                    title: '帐号安全',
                    sort: 3,
                    icon: "tl-icon-renzheng",
                    path: "/account/safety/index",
                    url: `${config.baseUrl.hosts.host}/account/safety/index`,
                    apply: 'crm'
                },
            },
            {
                key: "user_drop_menu",
                info: {
                    title: '购买记录',
                    sort: 4,
                    icon: "tl-icon-trade",
                    path: "/setting_base/buylist",
                    url: `${config.baseUrl.hosts.host}/setting_base/buylist`,
                    apply: 'crm',
                    roles: ['sys:bas:buyrecords']
                },
            },
            // 下拉（用户）导航 end

            // 下拉（帮助）导航 start
            {
                key: 'help_drop_menu',
                info: {
                    title: '常见问题',
                    sort: 0,
                    icon: "tl-icon-caozuoshouce",
                    path: "https://docs.qq.com/doc/DSUVWR01oSXF2Yk5Y"
                }
            },
            {
                key: 'help_drop_menu',
                info: {
                    title: '意见反馈',
                    sort: 2,
                    icon: "tl-icon-tool_",
                    path: "/feedback",
                    url: `${config.baseUrl.hosts.host}/feedback`,
                    apply: 'crm'
                },
            },
            {
                key: 'help_drop_menu',
                info: {
                    title: '在线咨询',
                    sort: 3,
                    icon: "tl-icon-zaixianzixun",
                    path: 'https://p.qiao.baidu.com/cps/chat?siteId=15859324&userId=31289153&siteToken=24e95499dfb9ae1e1093b0f6535e7c1e'
                },
            },
            {
                key: 'help_drop_menu',
                info: {
                    title: '关注服务号',
                    sort: 4,
                    icon: "tl-icon-weixinfuwuhao-1",
                    path: "/feedback",
                    url: `${config.baseUrl.hosts.host}/feedback`,
                    apply: 'crm'
                },
            },
            // 下拉（帮助）导航 end
        ]
    }
}

export default function (config) {
    return new TlCommonMenuLinks(...arguments)
}
